
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Forceurbanialuxuryminibusonrent() {



    const cardData =
    {
        keyword: 'Force Urbania Luxury Mini Bus On Rent',
        heading: 'Amruta Travels: Force Urbania Luxury Mini Bus On Rent',
        headingDescription: 'Amruta Travels offers Force Urbania Luxury Mini Bus on Rent in Pune, providing a premium and comfortable transportation solution for various occasions. Whether you are planning a corporate event, wedding, school trip, or a family outing, our fleet of luxurious Force Urbania mini buses ensures a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make group travel simple and stress-free. Choose from our range of Force Urbania mini buses, including 13-seater and 17-seater options, to suit your group size. Book your Force Urbania Luxury Mini Bus with Amruta Travels and travel together in comfort and style!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],
   "services": [
    {
      "name": "Force Urbania Luxury Mini Bus on Rent Hadapsar",
      "description": "Amruta Travels provides luxury Force Urbania mini buses on rent in Hadapsar, Pune. Ideal for premium group travel, these vehicles offer air conditioning, plush interiors, ample space, and smooth rides for outstation trips, family functions, or executive travel."
    },
    {
      "name": "13 Seater Urbania Bus Hire in Kharadi",
      "description": "Hire a 13-seater Urbania mini bus in Kharadi from Amruta Travels for efficient and comfortable transport. Perfect for short-distance city tours, airport transfers, or business trips, our Urbania buses come with AC, cushioned seating, and expert drivers."
    },
    {
      "name": "17 Seater Urbania Bus Hire in Kharadi",
      "description": "Looking for a 17-seater premium mini bus in Kharadi? Amruta Travels offers Force Urbania rentals with AC comfort, modern design, and spacious interiors—ideal for corporate events, weddings, and group outings across Pune or outstation destinations."
    },
    {
      "name": "Luxury Bus for Corporate Events Online Bus Booking",
      "description": "Book luxury Force Urbania buses online with Amruta Travels for your next corporate event. Whether it's a team offsite or VIP guest transportation, our mini buses provide a blend of elegance and practicality with AC, legroom, and professional service."
    },
    {
      "name": "Pune Airport Urbania Bus on Rent",
      "description": "Get reliable airport transfers with Amruta Travels’ Urbania buses for Pune Airport. Our luxury mini buses are perfect for family groups, business travelers, or wedding guests, ensuring timely pick-ups and drop-offs in complete comfort and style."
    },
    {
      "name": "Pune to Mumbai Airport Urbania Bus on Rent",
      "description": "Travel from Pune to Mumbai Airport in a premium Force Urbania mini bus with Amruta Travels. Enjoy a relaxed and punctual airport transfer experience with air-conditioned comfort, experienced drivers, and flexible pickup scheduling."
    },
    {
      "name": "Force Urbania Luxury Mini Bus on Rent for Outstation",
      "description": "Amruta Travels offers Force Urbania luxury mini buses for outstation trips from Pune. Ideal for small to medium groups traveling to destinations like Mahabaleshwar, Lonavala, or Shirdi, our Urbania fleet ensures a safe, clean, and comfortable journey."
    },
    {
      "name": "Urbania Bus Hire in Hinjewadi",
      "description": "Book a Force Urbania mini bus in Hinjewadi with Amruta Travels for corporate shuttles, airport transfers, or outstation journeys. Our vehicles are ideal for IT companies and residential societies needing professional and reliable transport solutions."
    },
    {
      "name": "Urbania Bus Hire in Aundh Baner",
      "description": "Hire a luxury Urbania bus in Aundh or Baner with Amruta Travels. Our service caters to executive transport, group tours, and event logistics, offering comfortable interiors, climate control, and experienced drivers across Pune’s western suburbs."
    },
    {
      "name": "Urbania Bus on Rent for Pune to Shirdi Darshan",
      "description": "Amruta Travels offers Force Urbania mini buses on rent for Pune to Shirdi Darshan tours. Experience spiritual travel in comfort with clean, air-conditioned vehicles and drivers experienced in handling devotional group itineraries and temple timings."
    }
  ],
  "tableData": [
    ["Force Urbania Luxury Mini Bus on Rent Hadapsar", "13 Seater Urbania Bus Hire in Kharadi"],
    ["17 Seater Urbania Bus Hire in Kharadi", "Luxury Bus for Corporate Events Online Bus Booking"],
    ["Pune Airport Urbania Bus on Rent", "Pune to Mumbai Airport Urbania Bus on Rent"],
    ["Force Urbania Luxury Mini Bus on Rent for Outstation", "Urbania Bus Hire in Hinjewadi"],
    ["Urbania Bus Hire in Aundh Baner", "Urbania Bus on Rent for Pune to Shirdi Darshan"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Compact Luxury for Group Travel",
    "WhyChoosedescription": "Amruta Travels offers Force Urbania Luxury Mini Bus On Rent, combining style, comfort, and practicality for group travel. Ideal for small to medium groups, this vehicle offers a premium experience in a compact size."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and VIP Travel",
    "WhyChoosedescription": "Whether you're organizing a corporate event, family outing, or transporting VIPs, the Force Urbania offers the perfect balance of luxury and space, ensuring your passengers travel in comfort and style."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Interiors",
    "WhyChoosedescription": "The Force Urbania boasts spacious, well-appointed interiors with comfortable seating, generous legroom, air conditioning, and ample storage space, making it perfect for long journeys or day trips."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are well-trained and courteous, ensuring a smooth and comfortable ride. They are experienced in handling the Force Urbania and are dedicated to providing a safe and pleasant journey."
  },
  {
    "WhyChooseheading": "Affordable Luxury with Transparent Pricing",
    "WhyChoosedescription": "Enjoy the luxury of the Force Urbania at a competitive price. We provide clear, upfront pricing with no hidden charges, ensuring you get the best value for your group’s travel needs."
  },
  {
    "WhyChooseheading": "Immaculately Maintained and Clean",
    "WhyChoosedescription": "Our Force Urbania vehicles are regularly serviced and cleaned to maintain the highest standards of hygiene and comfort, ensuring you a smooth and enjoyable travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-off, and Custom Routes",
    "WhyChoosedescription": "We offer flexible scheduling, with customized routes and pick-up/drop-off points to suit your specific travel plans, whether it's for a wedding, corporate event, or city tour."
  },
  {
    "WhyChooseheading": "Effortless Booking with Full Support",
    "WhyChoosedescription": "Booking a Force Urbania Luxury Mini Bus On Rent is quick and easy with Amruta Travels. Our friendly customer support team will assist you at every step, from booking to planning your journey."
  }
]
































    }

const faqData = [
  {
    question: 'How can I rent a Force Urbania Luxury Mini Bus in Pune with Amruta Travels?',
    answer: 'Renting a Force Urbania Luxury Mini Bus in Pune is easy with Amruta Travels. You can book online, call our support team, or visit our office. We’ll help you choose the ideal vehicle based on your group size and travel needs.',
  },
  {
    question: 'What are the features of the Force Urbania Luxury Mini Bus?',
    answer: 'The Force Urbania Luxury Mini Bus is equipped with luxurious interiors, premium seating, air conditioning, large windows for a scenic view, ample luggage space, and modern amenities, making it perfect for small groups looking for a comfortable and stylish ride.',
  },
  {
    question: 'What is the seating capacity of the Force Urbania Luxury Mini Bus?',
    answer: 'The Force Urbania Luxury Mini Bus typically accommodates 13 to 15 passengers comfortably. It’s ideal for small group outings, corporate events, and family trips where comfort and luxury are a priority.',
  },
  {
    question: 'Can the Force Urbania Luxury Mini Bus be used for outstation trips?',
    answer: 'Yes, the Force Urbania Luxury Mini Bus is perfect for both local and outstation trips. Whether you are planning a short day trip or a multi-day journey, it provides a luxurious and comfortable experience.',
  },
  {
    question: 'Are the Force Urbania Luxury Mini Buses well-maintained?',
    answer: 'Yes, all our Force Urbania Luxury Mini Buses are regularly maintained and cleaned before each trip. We ensure that every vehicle is in top condition for your safety and comfort.',
  },
  {
    question: 'Do I get a driver with the Force Urbania Luxury Mini Bus rental?',
    answer: 'Yes, every Force Urbania Luxury Mini Bus rental includes a professional, experienced driver who ensures a smooth, safe, and timely journey for you and your group.',
  },
  {
    question: 'What is the cost of renting a Force Urbania Luxury Mini Bus in Pune?',
    answer: 'The rental cost depends on factors like the duration of the trip, distance, and any additional services you may require. Please contact us for a detailed and customized quote based on your specific needs.',
  },
  {
    question: 'Can I choose multiple pickup and drop-off points for my trip?',
    answer: 'Yes, we offer flexible pickup and drop-off options. Just share your schedule and locations, and we’ll arrange the route to suit your requirements.',
  },
  {
    question: 'Why should I choose Amruta Travels for renting a Force Urbania Luxury Mini Bus?',
    answer: 'Amruta Travels offers top-quality Force Urbania Luxury Mini Buses, ensuring luxury, comfort, and reliability. Our vehicles are well-maintained, and our drivers are highly professional. We prioritize your comfort and safety at every step of your journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Suresh Jadhav',
    role: 'Corporate Manager, Pune',
    text: 'We hired a Force Urbania Luxury Mini Bus for our company’s team outing. The bus was fantastic! Clean, comfortable, and equipped with everything we needed. The driver was friendly and professional. Highly recommend this service for small group trips!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Neha Patil',
    role: 'Event Coordinator, Pune',
    text: 'For a wedding guest transport, we booked a Force Urbania Luxury Mini Bus. The luxury and comfort it provided were top-notch. Our guests were impressed with the spacious seating and smooth ride. Thank you, Amruta Travels, for making it a great experience!',
    rating: 5,
  },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania Luxury Mini Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/force-urbania-luxury-mini-bus-rent.jpg",
  "description": "Book Force Urbania luxury mini buses in Pune for outstation trips, corporate events, airport transfers, and temple darshans. Available in 13-seater and 17-seater options for group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "50", // Adjust based on per km or flat rate for Force Urbania rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/force-urbania-luxury-mini-bus-on-rent"
  }
};



    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Force Urbania Luxury Mini Bus on Rent in Pune | 13 & 17 Seater Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent Force Urbania luxury mini buses in Pune for corporate events, outstation trips, airport transfers, and temple darshans. Available in 13 and 17-seater options for comfortable travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbanialuxuryminibusonrent;